import { ReviewRepository } from "../../repositories/ReviewRepository";
import { ReviewRequestEntity } from "../../entities/ReviewEntity";

/**
 * Get My Review Requests Use Case
 * Retrieves review requests created by current user
 */
export class GetMyReviewRequestsUseCase {
  constructor(private repository: ReviewRepository) {}

  async execute(): Promise<ReviewRequestEntity[]> {
    return await this.repository.getMyReviewRequests();
  }
}
